import * as THREE from 'three';
import { FikoGrup } from '../FikoGrup';
import { FikoSahne } from '../FikoSahne';
import { FikoOperasyon } from './Fikoperasyon';
import { jsondan } from '../../FikoThreeType';

export class FikoOperasyonlar extends FikoGrup {
    override type: any = "Fikoperasyonlar";
    /** */
    sayac = 1;

    sagButonlar = [
        {
            baslik: "Operasyon Ekle",
            simge: "plus",
            tiklandi: () => {
                this.ekleFikoperasyon();
            }
        },
        {
            baslik: "Dosyadan Yukle",
            simge: "upload",
            tiklandi: () => {
                FikoOperasyon.dosyadanYukle(this.sahne, this).then((op) => {
                    if (op) {
                        this.ekle(op);
                        this.sahne?.anaGosterim?.FikoYT?.degisti?.emit();
                        this.sahne?.anaGosterim?.ciz();
                    }
                });
            }
        }
    ]

    public override get liste(): FikoOperasyon[] {
        return this.children as FikoOperasyon[];
    }

    constructor(public override sahne?: FikoSahne, name?: string) {
        super(sahne);
        this.name = name;
        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = true;
        this.userData['FikoArayuz'].simge = "./simgeler/organizasyon.webp";
    }

    ekleFikoperasyon(isim?: string) {
        this.ekle(new FikoOperasyon(this.sahne, isim ? isim : 'Fikoperasyon.' + this.sayac));
        this.sayac += 1;
    }

    override toJSON(meta?: { geometries: any; materials: any; textures: any; images: any }): any {
        const _rslt: any = { type: this.type, isim: this.name, uuid: this.uuid } // super.toJSON(meta);

        const childs: any[] = []
        for (let index = 0; index < this.children.length; index++) {
            const element = this.children[index];

            childs.push(element.toJSON());
        }
        _rslt.operasyonlar = childs;

        _rslt.userData = this._serializeUserData();
        _rslt.visible = this.visible;

        return _rslt;
    }

    static fromJson(sahne?: FikoSahne, parent?: any, json?: any) {
        const _rslt = new FikoOperasyonlar(sahne, json.isim);
        _rslt.uuid = json.uuid;

        _rslt.parent = parent;

        for (let i = 0; i < json.operasyonlar.length; i++) {
            let element = json.operasyonlar[i];
            _rslt.children[i] = jsondan(sahne, _rslt, element);
        }

        if (json.userData) _rslt._restoreUserData(json.userData);
        if (json.visible !== undefined) _rslt.visible = json.visible;

        return _rslt;
    }

    toStr() {
        let _rslt = `{ "uuid":"${this.uuid}","ismi": "${this.name}","type":"${this.type}","children":[`;
        for (let i = 0; i < this.liste.length; i++) {
            const element = this.liste[i];
            if (i > 0) _rslt += `,`
            _rslt += element.toStr();
        }
        _rslt += `] }`;
        return _rslt;
    }

}